import { SubmitEvent, ReactNode } from 'react';
import { useFormContext } from '@/lib/form.ts';

export interface FormProps {
  children?: ReactNode;
}

export const Form = ({ children }: FormProps) => {
  const form = useFormContext();

  return (
    <form onSubmit={handleFormSubmitAdapter(form.handleSubmit)} noValidate>
      {children}
    </form>
  );
};

function handleFormSubmitAdapter(onSubmit: () => void) {
  return (e: SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onSubmit();
  };
}
